import { IStoreState, Selector } from '../types';

export const selectTableSessionId: Selector<string> = (state: IStoreState) => state.auth.tableSessionId;
export const selectUserOrderSessionId: Selector<string> = (state: IStoreState) => state.auth.userOrderSessionId;
export const selectSelectedRestaurantId: Selector<string> = (state: IStoreState) => state.auth.selectedRestaurantId;
export const selectJwtToken: Selector<string> = (state: IStoreState) => state.auth.jwtToken;
